<template>
    <div>
        <van-nav-bar :title="title" :left-text="arrow==false?'':'返回'" :left-arrow="arrow" @click-left="goBack" />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        arrow: {
            type: Boolean ,
            default: '',
        },
    },
    data() {
        return {
        };
    },
    mounted() {

    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/pages/qiwei/keleshou/component/nav.vue